export default __webpack_public_path__ + "static/media/wallpaper.c866d607.jpg";